export { settingsNavItems, settingsRoutes } from './settings';
export { settingsPermissions } from './permissions';

export const reportRoutes = ({ accountScopedRoute, t }) => [
  {
    name: 'Reports Ads',
    label: t('SIDEBAR.REPORTS_ADS'),
    to: accountScopedRoute('ads_reports'),
  },
];
